import AddToCalendar from "../AddToCalendar";
import {FormattedDate} from "./FormattedDate";
import {getGoogleMapLink} from "../../utils/google-maps";
import EventRegistrationButton from "../EventRegistrationButton";

const EventHeader = ({event, eventLoaded}) => {
	return eventLoaded ? <HeaderWithDataLoaded event={event}/> : <HeaderNoDataLoaded/>;
}

const HeaderNoDataLoaded = () => {
	// Mirror the resolved header's structure (figure + .event-main > .event-copy) so the same
	// layout CSS positions the placeholders where the real content will land — minimizing the
	// layout shift when event data resolves.
	return (
		<header className="event-detail-header loading">
			<figure id="event_featured_image" className="event-loading-placeholder"/>
			<div className="event-main">
				<div className="event-copy">
					<h1 className="event-title event-loading-placeholder">&nbsp;</h1>
					<div className="event-date event-loading-placeholder"/>
					<div className="event-location event-loading-placeholder"/>
					<div className="event-actions">
						<span className="event-loading-placeholder"/>
						<span className="event-loading-placeholder"/>
					</div>
					<div className="share event-loading-placeholder"/>
				</div>
			</div>
		</header>
	)
}

const HeaderWithDataLoaded = ({event}) => {
	const figureStyle = {backgroundImage: `url("${event.bio_featureimageurl}")`}
	const twitterIntentUrl = encodeURI(`https://twitter.com/intent/tweet?url=${window.location}&text=${event.msevtmgt_name}`)

	return (
		<header className='event-detail-header'>

			<figure style={figureStyle} id='event_featured_image'/>

			<div className='event-main'>
				<MembersOnlyTag event={event}/>

				<div className='event-copy'>
					<h1>{event.msevtmgt_name}</h1>

					<div className={'event-date'}>
						<FormattedDate start={event.eventDatesUnformatted.start} end={event.eventDatesUnformatted.end}/>
					</div>


					<EventLocation event={event}/>

					<div className={'event-actions'}>
						<EventRegistrationButton event={event}/>
						<AddToCalendar event={event}/>
					</div>

					<section className={'share social a2a_kit'}>
						Share

						<a href={`https://www.linkedin.com/sharing/share-offsite/?url=${window.location}`}
						   title='Share this event on LinkedIn'>
							<i className="icon icon-linkedin"/>
						</a>

						<a href={twitterIntentUrl} title='Share this event on X'>
							<i className="icon icon-twitter"/>
						</a>

						<a href={`mailto:?subject=${encodeURIComponent(event.msevtmgt_name)}&body=${encodeURIComponent(window.location.href)}`}
						   className="email a2a_button_email"
						   title="Share this event via email">
							<i className="fa icon-envelope-o"></i>
						</a>
					</section>
				</div>
			</div>
		</header>
	)
}

const MembersOnlyTag = ({event}) => {
	return event.membersOnly ? <div className={'members-only'}>Members only</div> : null
}

const EventLocation = ({event}) => {
	const {
		city,
		name,
		street,
	} = event.venue;

	if (!event.venue.name) {
		return null;
	}

	if (!city) {
		const output = street ? `${name} - ${street}` : name;
		return <span className='event-location'>{output}</span>
	}

	const addressParts = Object.values(event.venue);
	const venueOutput = `${addressParts.slice(0, 4).join(', ')} ${addressParts[addressParts.length - 1]}`;

	return <a className='event-location' href={getGoogleMapLink(event.venue)} target={'_blank'} rel="noreferrer">{venueOutput}</a>;
}

export default EventHeader;
